<template>
  <el-dialog
    top="10vh"
    class="edit-dialog"
    :title="row.id ? '编辑' : '新建'"
    :visible.sync="dialogVisible"
    :before-close="notBtn"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="600px"
  >
    <el-form ref="form" :model="form" :rules="rules" size="small" label-width="180px">
      <el-form-item label="品牌：" prop="brand">
        <Select
          style="width: 240px;"
          placeholder="品牌"
          v-model="form.brand"
          :query="$api.basicdata.basic_wine_select + '?type=1'"
          :labelOptions="{
            key: 'name',
            value: 'name'
          }"
        >
        </Select>
      </el-form-item>
      <el-form-item label="分类：" prop="classify">
        <Select
          style="width: 240px;"
          placeholder="分类"
          v-model="form.classify"
          :query="$api.basicdata.basic_wine_select + '?type=2'"
          :labelOptions="{
            key: 'name',
            value: 'name'
          }"
        >
        </Select>
      </el-form-item>
      <el-form-item label="产地：" prop="origin">
        <Select
          style="width: 240px;"
          placeholder="产地"
          v-model="form.origin"
          :query="$api.basicdata.basic_wine_select + '?type=3'"
          :labelOptions="{
            key: 'name',
            value: 'name'
          }"
        >
        </Select>
      </el-form-item>
      <el-form-item label="容量：" prop="capacity">
        <Select
          style="width: 240px;"
          placeholder="容量"
          v-model="form.capacity"
          :query="$api.basicdata.basic_wine_select + '?type=4'"
          :labelOptions="{
            key: 'name',
            value: 'name'
          }"
        >
        </Select>
      </el-form-item>
      <el-form-item label="类型：" prop="type">
        <Select
          style="width: 240px;"
          placeholder="类型"
          v-model="form.type"
          :query="$api.basicdata.basic_wine_select + '?type=5'"
          :labelOptions="{
            key: 'name',
            value: 'name'
          }"
        >
        </Select>
      </el-form-item>
      <el-form-item label="酒柜类型：" prop="room">
        <Select
          style="width: 240px;"
          placeholder="酒柜类型"
          v-model="form.room"
          :options="[
            {
              code: 1,
              name: '单间室'
            },
            {
              code: 2,
              name: '双间室'
            }
          ]"
        >
        </Select>
      </el-form-item>
      <el-form-item label="推荐设置温度(℃)：" prop="storageTemp">
        <el-input-number
          v-model.trim="form.storageTemp"
          :step="1"
          step-strictly
          :min="0"
          :max="100"
          placeholder="推荐设置温度"
          controls-position="right"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="notBtn">取 消</el-button>
      <el-button type="primary" @click="okBtn">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import Select from '@manage/components/CommonForm/Select'
export default {
  name: 'Dialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    row: {
      type: Object
    }
  },
  components: {
    Select
  },
  data() {
    return {
      dialogVisible: this.visible,
      form: {
        id: '',
        brand: '',
        classify: '',
        origin: '',
        capacity: '',
        type: '',
        room: '',
        storageTemp: 10
      },
      rules: {
        brand: [
          {
            required: true,
            message: '请选择品牌',
            trigger: 'change'
          }
        ],
        classify: [
          {
            required: true,
            message: '请选择分类',
            trigger: 'change'
          }
        ],
        origin: [
          {
            required: true,
            message: '请选择产地',
            trigger: 'change'
          }
        ],
        capacity: [
          {
            required: true,
            message: '请选择容量',
            trigger: 'change'
          }
        ],
        type: [
          {
            required: true,
            message: '请选择类型',
            trigger: 'change'
          }
        ],
        room: [
          {
            required: true,
            message: '请选择酒柜类型',
            trigger: 'change'
          }
        ],
        storageTemp: [
          {
            required: true,
            message: '请填写推荐设置温度',
            trigger: ['blur', 'change']
          }
        ]
      },
      addApi: this.$api.wine.inventory_add,
      updateApi: this.$api.wine.inventory_update
    }
  },
  mounted() {
    if (this.row.id) {
      this.queryDetail(this.row)
    }
  },
  methods: {
    queryDetail(row) {
      this.form = JSON.parse(JSON.stringify(row))
    },
    notBtn() {
      this.$emit('update:visible', false)
    },
    okBtn() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = {
            id: this.form.id,
            brand: this.form.brand,
            classify: this.form.classify,
            origin: this.form.origin,
            capacity: this.form.capacity,
            type: this.form.type,
            room: this.form.room,
            storageTemp: this.form.storageTemp
          }

          let api = this.row.id ? this.updateApi : this.addApi
          this.$ajax.post(api, params).then(() => {
            this.$message.success(`${this.row.id ? '修改成功' : '新建成功'}`)
            this.notBtn()
            this.$emit('refresh')
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.edit-dialog {
  .el-form-item__content {
    div {
      width: 240px;
    }
  }
}
</style>
